//#region Util Imports

import * as $ from 'jquery'
import * as _ from 'underscore'

//#endregion

import { Api } from './api.module'
import {
	DictionaryModel,
	ColumnModel,
	DataTypeModel,
	DataTypeGroupModel,
	FormatModel,
	ActiveViewModel,
	ActiveViewColumnModel,
	GridRequestReferenceModel,
	GridModel,
	DataTypeInGroupModel,
	GridRequestModel,
} from './api.models'
import { LoggerService } from '../common/common.logger.service'
import { i18n } from '../common/i18n/common.i18n'
import { CommonHelper, DataType, ChartType, ViewColumnType } from '../../helpers/common-helper'
import { Dictionary } from '../../helpers/dictionary'
import { IUserSession } from '../../helpers/user-session'
import { IReferenceType } from '../../models/util/interfaces'
import { Enums } from '../../models/common/enums'
import { KnownColor } from '../../models/common/known-colors'

import { OpDataType } from '../../models/core/op-data-type'
import { OpDataTypeGroup } from '../../models/core/op-data-type-group'
import { OpDataTypeInGroup } from '../../models/core/op-data-type-in-group'
import { OpDescr } from '../../models/core/op-descr'
import { OpDistributor } from '../../models/core/op-distributor'
import { OpDistributorHierarchy } from '../../models/core/op-distributor-hierarchy'
import { OpModule } from '../../models/core/op-module'
import { OpUnit } from '../../models/core/op-unit'
import { OpView, GetViewColumnOptions } from '../../models/core/op-view'
import { OpEnumObject, ColumnInfo } from '../../models/custom'

import { LocalizationHelper, ReferenceTypeComponent, ConfigHelper } from '../../helpers'
import { DataProviderListResult } from 'app/data-provider'
import { OpConfigurationProfile, OpViewColumn } from 'app/models/core'

declare var msgpack: any

class ExtendedDictionaryModel extends DictionaryModel {
	public views: { [key: string]: OpView }
}

export class LocalDictionaryFactory {
	public static dictionaries: ExtendedDictionaryModel = null

	private locale: string
	private operatorId: number
	private version: number
	private promise: ng.IPromise<ExtendedDictionaryModel>
	private colors: any = {}

	constructor(private api: Api, private logger: LoggerService, private $q: ng.IQService, protected userSession: IUserSession) { }

	private arrayToColumnModel(array: any[]) {
		var result = new ColumnModel()
		result.alignment = array[0]
		result.caption = array[1]
		result.cellTemplate = array[2]
		result.chartType = array[3]
		result.editCellTemplate = array[4]
		result.format = array[5]
		result.hidden = array[6]
		result.id = array[7]
		result.idName = array[8]
		result.isEditable = array[9]
		result.lookup = array[10]
		result.name = array[11]
		result.position = array[12]
		result.referenceTypeId = array[13]
		result.sortDesc = array[14]
		result.type = array[15]
		result.typeName = array[16]
		result.unitId = array[17]
		result.unitName = array[18]
		result.where = array[19]
		result.width = array[20]
		return result
	}

	private decodeString(encoded: string) {
		var byteNumbers = new Array(encoded.length)
		for (let i = 0; i < encoded.length; i++) {
			byteNumbers[i] = encoded.charCodeAt(i)
		}

		return msgpack.decode(byteNumbers)
	}

	private decodeDictionaries(data): ExtendedDictionaryModel {
		var result = new ExtendedDictionaryModel()

		if (!angular.isArray(data)) {
			return data
		}

		var dataTypeGroups: any[][] = data[0]
		result.dataTypeGroups = dataTypeGroups.map((dtg) => {
			var r = new DataTypeGroupModel()
			r.idDataTypeGroup = dtg[0]
			r.idParentGroup = dtg[1]
			r.idReferenceType = dtg[2]
			r.name = dtg[3]
			r.referenceValue = dtg[4]
			return r
		})

		var dataTypeInGroups: any[][] = data[1]
		result.dataTypeInGroups = {}
		for (let i in dataTypeInGroups) {
			result.dataTypeInGroups[i] = dataTypeInGroups[i].map(
				(dtin) =>
					<DataTypeInGroupModel>{
						description: dtin[0],
						idDataType: dtin[1],
						order: dtin[2],
					}
			)
		}

		var dataTypes = data[2]
		result.dataTypes = {}
		for (let i in dataTypes) {
			var dataType = dataTypes[i]
			var r = new DataTypeModel()
			r.caption = dataType[0]

			var format = dataType[3]
			var f = new FormatModel()
			f.dateTimeFormat = format[0]
			f.isRequired = format[1]
			f.numberMaxPrecision = format[2]
			f.numberMaxScale = format[3]
			f.numberMaxValue = format[4]
			f.numberMinPrecision = format[5]
			f.numberMinScale = format[6]
			f.numberMinValue = format[7]
			f.textMaxLength = format[8]
			f.textMinLength = format[9]

			r.format = f
			r.dataTypeClass = dataType[1]
			r.defaultValue = dataType[2]
			r.idDataType = dataType[4]
			r.isEditable = dataType[5]
			r.name = dataType[6]
			r.opState = dataType[7]
			r.referenceTypeId = dataType[8]
			r.type = dataType[9]
			r.typeName = dataType[10]
			r.unitId = dataType[11]
			r.unitName = dataType[12]

			result.dataTypes[i] = r
		}

		result.distributors = data[3].map((d) => this.arrayToColumnModel(d))
		result.modules = data[4].map((d) => this.arrayToColumnModel(d))
		result.referenceIds = data[5]
		var references = data[6]
		result.references = {}
		for (let i in references) {
			result.references[i] = references[i].map((d) => this.arrayToColumnModel(d))
		}

		result.units = data[7].map((d) => this.arrayToColumnModel(d))

		var views = data[8]
		result.views = {}
		for (let i in views) {
			var v = views[i]
			var columns = v[1].map((column) => {
				var c = new ActiveViewColumnModel()
				c.caption = column[0]
				c.dataType = this.encodeOpDataType(column[1])
				c.idDataType = column[2]
				c.idKeyViewColumn = column[3]
				c.idViewColumn = column[4]
				c.idViewColumnType = column[5]
				c.indexNbr = column[6]
				c.name = column[7]
				c.primaryKey = column[8]
				c.table = column[9]
				return c
			})

			var view = new ActiveViewModel()
			view.caption = v[0]
			view.columns = columns
			view.id = v[2]
			view.idReferenceType = v[3]

			result.views[i] = OpView.getActiveViewFromActiveViewModel(view)
		}

		return result
	}

	private encodeOpDataType(dataType: any[]): OpDataType {
		const opDataType = new OpDataType()
		opDataType.dataTypeClass = dataType[0]
		opDataType.dataTypeFormat = dataType[1]
		opDataType.descr = this.encodeOpDescr(dataType[2])
		opDataType.referenceType = dataType[3]
		opDataType.unit = dataType[4]

		opDataType.idDataType = dataType[6]
		opDataType.idDataTypeClass = dataType[7]
		opDataType.idDataTypeFormat = dataType[8]
		opDataType.idDescr = dataType[9]
		opDataType.idReferenceType = dataType[10]
		opDataType.idUnit = dataType[11]
		opDataType.isEditable = dataType[13]
		opDataType.name = dataType[16]
		opDataType.opState = dataType[17]

		return opDataType
	}

	private encodeOpDescr(descr: any[]): OpDescr {
		if (!descr) return null

		const opDescr = new OpDescr()

		opDescr.description = descr[2]
		opDescr.extendedDescription = descr[3]
		opDescr.idDescr = descr[4]
		opDescr.idLanguage = descr[5]
		opDescr.idServer = descr[6]
		opDescr.opState = descr[7]

		return opDescr
	}

	private encodeDictionaries(decoded: any) {
		var buffer = msgpack.encode(decoded)
		var string = ''
		for (var i = 0; i < buffer.length; i++) {
			string += String.fromCharCode(buffer[i])
		}
		return string
	}

	private getDictionariesInfo() {
		var dictionaryInfo: { dictionary: string; locale: string; version: number; user: number; activeViews: any } = CommonHelper.getValueFromLocalStorage('DICTIONARY')
		return dictionaryInfo
	}

	private getDictionaries(): ExtendedDictionaryModel {
		return LocalDictionaryFactory.dictionaries
	}

	private saveDictionaries(dictionary: string, locale: string, version: number, user: number) {
		CommonHelper.setValueToLocalStorage('DICTIONARY', { dictionary, locale, version, user })
		CommonHelper.setValueToLocalStorage('DATE', new Date())
	}

	public getPromise(): ng.IPromise<ExtendedDictionaryModel> {
		if (this.promise) return this.promise
		else return this.refreshDictionaries()
	}

	private getFieldFromDictionary(name: string): ng.IPromise<any> {
		return this.getPromise().then((dictionaries) => {
			return this.getDictionaries()[name]
		})
	}

	public asyncGetReferenceTables() {
		return this.getPromise().then((dictionaries) => {
			var ids: number[] = []
			var i = 0
			while (ids.length < 10 && LocalDictionaryFactory.dictionaries.referenceIds.length > i) {
				if (!LocalDictionaryFactory.dictionaries.references[LocalDictionaryFactory.dictionaries.referenceIds[i]] && LocalDictionaryFactory.dictionaries.referenceIds[i] != CommonHelper.IdDataType) {
					ids.push(LocalDictionaryFactory.dictionaries.referenceIds[i])
				}
				i++
			}

			if (ids.length > 0) {
				if (window['config'].USE_REST_API) {
					this.userSession
						.getDataProvider()
						.getReferenceTables(ids)
						.then((tables) => {
							this.updateReferenceTablesInDictionary(dictionaries, tables, ids)
							setTimeout(() => {
								this.asyncGetReferenceTables()
							}, 5000)
						})
				} else {
					this.api.dictionary.getDictionaryReferenceTables(ids).then((res) => {
						var decodedTables = this.decodeString(CommonHelper.Base64.decode(res))
						this.updateReferenceTablesInDictionary(dictionaries, decodedTables, ids)
						setTimeout(() => {
							this.asyncGetReferenceTables()
						}, 5000)
					})
				}
			}
		})
	}

	private updateReferenceTablesInDictionary(dictionaries: ExtendedDictionaryModel, references, referenceIds: number[]) {
		referenceIds.forEach((id) => {
			if (window['config'].USE_REST_API) {
				dictionaries.references[id] = references[id] || []
			} else {
				dictionaries.references[id] = references[id] ? references[id].map((d) => this.arrayToColumnModel(d)) : []
			}
		})
		LocalDictionaryFactory.dictionaries = dictionaries
		var encoded = this.encodeDictionaries(dictionaries)
		this.saveDictionaries(encoded, this.locale, this.version, this.operatorId)
	}

	private getDataTypeInGroup(
		dataTypeGroups: DataTypeGroupModel[],
		dataTypesInGroup: {},
		dataTypeGroupName: string,
		referenceType: number = null,
		referenceValue: number = null
	): DataTypeInGroupModel[] {
		var result = []

		var group: DataTypeGroupModel = null

		if (referenceType == null || referenceValue == null) {
			var groups = dataTypeGroups.filter((g) => g.name == dataTypeGroupName && g.idReferenceType == null && g.referenceValue == null)
			if (groups.length > 0) group = groups[0]
		} else {
			var groups = dataTypeGroups.filter((g) => g.name == dataTypeGroupName && g.idReferenceType == referenceType && g.referenceValue !== null && +g.referenceValue === referenceValue)

			if (groups.length == 0) {
				groups = dataTypeGroups.filter((g) => g.name == dataTypeGroupName && g.idReferenceType == null && g.referenceValue == null)
				if (groups.length > 0) group = groups[0]
			} else {
				group = groups[0]
			}
		}

		if (group == null) return result

		var dataTypeInGroup: DataTypeInGroupModel[] = dataTypesInGroup[group.idDataTypeGroup]
		if (!dataTypeInGroup) return result
		else if (!group.idParentGroup) return dataTypeInGroup

		var dataTypeInParentGroup: DataTypeInGroupModel[] = dataTypesInGroup[group.idParentGroup]
		if (!dataTypeInParentGroup) return dataTypeInGroup

		result.push(...dataTypeInParentGroup)

		dataTypeInGroup.forEach((item) => {
			var index = -1
			result.some((d, i) => {
				if (d.idDataType == item.idDataType) {
					index = i
					return true
				}
				return false
			})
			if (index > -1) {
				result[index] = item
			} else {
				result.push(item)
			}
		})

		return result
	}

	private getDictionary(model: string, referenceType: number = null, referenceValue: number = null): ng.IPromise<ColumnModel[]> {
		return this.getPromise().then((dictionaries) => {
			var result: ColumnModel[] = []

			var dataTypeInGroups = this.getDataTypeInGroup(dictionaries.dataTypeGroups, dictionaries.dataTypeInGroups, model, referenceType, referenceValue)
			dataTypeInGroups.forEach((dtin) => {
				var dataType: DataTypeModel = $.extend(true, {}, dictionaries.dataTypes[dtin.idDataType])
				if (dataType) {
					if (dtin.description) dataType.caption = dtin.description
					if (dtin.order) dataType['order'] = dtin.order

					result.push(this.dataTypeToColumn(dtin.idDataType, dataType))
				}
			})

			result = _.sortBy(result, (column) => column['orderNbr'])

			if (window['config'].DEBUG && dataTypeInGroups.length == 0) {
				console.info('No dataTypes in ' + model + '\n' + 'Reference type: ' + referenceType + '\n' + 'Reference value: ' + referenceValue)
			}

			var referenceTypes = _.map(result, (column) => column.referenceTypeId).filter((value) => !!value)
			for (var i = referenceTypes.length - 1; i >= 0; i--) {
				var refType = referenceTypes[i]
				if (LocalDictionaryFactory.dictionaries.references[refType]) {
					referenceTypes[i] = null
				}
			}

			referenceTypes = referenceTypes.filter((value) => !!value)
			referenceTypes = _.uniq(referenceTypes)

			if (referenceTypes.length > 0) {
				if (window['config'].USE_REST_API) {
					var defer = this.$q.defer<ColumnModel[]>()
					this.userSession
						.getDataProvider()
						.getReferenceTables(referenceTypes)
						.then((tables) => {
							this.updateReferenceTablesInDictionary(dictionaries, tables, referenceTypes)
							defer.resolve(result)
						})
					return defer.promise
				} else {
					return this.api.dictionary.getDictionaryReferenceTables(referenceTypes).then((res) => {
						var decodedTables = this.decodeString(CommonHelper.Base64.decode(res))
						this.updateReferenceTablesInDictionary(dictionaries, decodedTables, referenceTypes)
						return result
					})
				}
			} else return result
		})
	}

	getDashboardDictionary() {
		return this.getPromise().then((dictionaries) => {
			var referenceTypes = [CommonHelper.IdDistributor, CommonHelper.IdProfile, CommonHelper.IdLanguage]
			var defer = this.$q.defer<ColumnModel[]>()
			var references = this.getDictionaries().references
			var tablesExists = referenceTypes.every((ref) => {
				return references[ref] ? true : false
			})
			if (tablesExists) defer.resolve()
			else
				this.userSession
					.getDataProvider()
					.getReferenceTables(referenceTypes)
					.then((tables) => {
						this.updateReferenceTablesInDictionary(dictionaries, tables, referenceTypes)
						defer.resolve()
					})
			return defer.promise
		})
	}

	getDistributorHierarchyDictionary() {
		return this.getPromise().then((dictionaries) => {
			var referenceTypes = [CommonHelper.IdDistributorHierarchy]
			var defer = this.$q.defer<ColumnModel[]>()
			var references = this.getDictionaries().references
			var tablesExists = referenceTypes.every((ref) => {
				return references[ref] ? true : false
			})
			if (tablesExists) defer.resolve()
			else
				this.userSession
					.getDataProvider()
					.getReferenceTables(referenceTypes)
					.then((tables) => {
						this.updateReferenceTablesInDictionary(dictionaries, tables, referenceTypes)
						defer.resolve()
					})
			return defer.promise
		})
	}

	private getColumnsWithNames(columns: ColumnModel[], idReferenceType: number): ng.IPromise<ColumnModel[]> {
		let defer = this.$q.defer<ColumnModel[]>()
		this.userSession
			.getDataProvider()
			.View.getActiveView(idReferenceType)
			.then((activeView) => {
				if (!activeView) {
					if (window['config'].DEBUG) {
						console.info('No view found: ' + idReferenceType)
					}
					defer.resolve(columns)
				} else {
					var viewColumns = activeView.columns
					var result: ColumnModel[] = []
					viewColumns.forEach((vc) => {
						columns.forEach((c) => {
							if (vc.idDataType == c.id) {
								var column = new ColumnModel()
								column.id = c.id
								column.caption = c.caption
								column.name = vc.name.toLowerCase()
								column.type = c.type
								column.referenceTypeId = c.referenceTypeId
								column.isEditable = c.isEditable
								column.format = c.format
								column.unitId = c.unitId
								column.unitName = c.unitName
								column['orderNbr'] = c['orderNbr']
								column.skipTranslation = vc.shouldSkipTranslation
								column.hidden = vc.isHidden
								column.alwaysHidden = vc.isHidden
								column.showInColumnChooser = !vc.isHidden

								result.push(column)
							}
						})
					})

					defer.resolve(result)
				}
			})
		return defer.promise
	}

	private dataTypeToColumn(id: number, dataType: DataTypeModel) {
		var column = new ColumnModel()
		column.id = id
		column.caption = dataType.caption
		column.name = dataType.name
		column.type = dataType.type
		column.referenceTypeId = dataType.referenceTypeId
		column.isEditable = dataType.isEditable
		column.format = dataType.format
		column.unitId = dataType.unitId
		column.unitName = dataType.unitName
		column['orderNbr'] = dataType['order']
		column['defaultValue'] = dataType.defaultValue
		return column
	}

	public getAllColumns(): ng.IPromise<ColumnModel[]> {
		return this.getPromise().then((dictionaries) => {
			var columns: ColumnModel[] = []
			for (var id in dictionaries.dataTypes) {
				var dataType: DataTypeModel = dictionaries.dataTypes[id]
				columns.push(this.dataTypeToColumn(+id, dataType))
			}

			return columns
		})
	}

	//private get
	public getSelectBoxData(referenceId: number): ng.IPromise<{ selectBoxData: any[] }> {
		return this.getFieldFromDictionary('references').then((references) => {
			var res = <{ selectBoxData: any[] }>{}
			res.selectBoxData = references[referenceId]
			return res
		})
	}

	public isReferenceTableInLocalDictionary(referenceId: number) {
		var references = LocalDictionaryFactory.dictionaries.references
		return references[referenceId] && references[referenceId].length > 0
	}

	public getActiveViews(): { [key: string]: OpView } {
		if (LocalDictionaryFactory.dictionaries && LocalDictionaryFactory.dictionaries.views) {
			for (let i in LocalDictionaryFactory.dictionaries.views) {
				LocalDictionaryFactory.dictionaries.views[i] = OpView.restore(LocalDictionaryFactory.dictionaries.views[i])
			}
			return LocalDictionaryFactory.dictionaries.views
		}
		return null
	}

	public getReferenceTable(
		referenceId: number,
		dataTypeId: number,
		pageNbr?: number,
		pageSize: number = 2147483647 /*Int32.MaxValue*/,
		columns?: ColumnModel[],
		where?: string,
		forceRequest?: boolean
	): ng.IPromise<{ selectBoxData: ColumnModel[]; gridData: GridModel }> {
		if (referenceId == 140) console.warn('Dont use selectBox for referenceId=140//IdDistributorHierarchy')
		return this.getFieldFromDictionary('references').then((references) => {
			const table = <{ selectBoxData: ColumnModel[]; gridData: GridModel }>{}

			let selectedBoxData = null

			if (referenceId != CommonHelper.IdDataType) {
				if (references[referenceId]) {
					selectedBoxData = references[referenceId]
				}
			} else if (angular.isArray(LocalDictionaryFactory.dictionaries.dataTypes)) {
				selectedBoxData = LocalDictionaryFactory.dictionaries.dataTypes
			} else {
				selectedBoxData = $.map(LocalDictionaryFactory.dictionaries.dataTypes, (dataType) => [dataType])
			}

			table.selectBoxData = selectedBoxData

			const model: GridRequestReferenceModel = new GridRequestReferenceModel()
			model.pageNumber = pageNbr
			model.pageSize = pageSize
			model.idReferenceType = referenceId
			model.idDataType = dataTypeId
			model.where = where
			model.columns = columns

			if (model.columns == null || model.columns.length == 0) {
				const activeView: OpView = this.getActiveView(model.idReferenceType)

				if (activeView != null) {
					const primaryColumn: OpViewColumn = activeView.getPrimaryKeyColumn()
					const column: ColumnModel = new ColumnModel()
					column.id = primaryColumn.idDataType
					column.name = primaryColumn.name
					model.columns = [column]
				} else {
					model.columns = [
						<ColumnModel>{
							id: 1,
							name: '1',
							idName: 'name',
							type: 3,
							caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Name),
						},
					]
				}
			}

			if (referenceId == Enums.ReferenceType.IdConfigurationProfile) {
				const deferred = this.$q.defer<any>()
				this.userSession
					.getDataProvider()
					.System
					.getReferenceObjectList(referenceId, [], null, 1, pageSize, '', null)
					.then((result: DataProviderListResult<IReferenceType>) => {
						table.gridData = null
						table.selectBoxData = _.map(result.objects, (profile: OpConfigurationProfile) => {
							return <ColumnModel>{
								id: profile.idConfigurationProfile,
								caption: profile.toString()
							}
						})

						deferred.resolve(table)
					})

				return deferred.promise
			} else {

				if (pageNbr && forceRequest) {
					console.log('Downloading...')
					console.groupEnd()

					return this.api.app.getReferenceObjectList(model).then((result) => {
						if (!result || !result.values) return table

						table.gridData = result
						return table
					})
				} else if ((!table.selectBoxData || table.selectBoxData.length == 0) && pageNbr) {
					table.selectBoxData = []
					console.log("Reference doesn't exist. Downloading...")
					console.groupEnd()

					return this.api.app.getReferenceObjectList(model).then((result) => {
						if (!result || !result.values) return table

						table.gridData = result

						_.forEach(result.values, (value: any) => {
							table.selectBoxData.push(<ColumnModel>{
								id: value.id,
								caption: value.valueString || value.valuestring,
							})
						})
						return table
					})
				} else {
					console.log('Reference rows: ' + !!table.selectBoxData + ' gridData? ' + !!table.gridData)
				}

				console.groupEnd()
				return table
			}
		})
	}

	public getReferenceValueCaption(referenceId: number, dataTypeId: number, value: any): ng.IPromise<{ value: any }> {
		return this.getFieldFromDictionary('references').then((references) => {
			var datas = referenceId != CommonHelper.IdDataType ? references[referenceId] : LocalDictionaryFactory.dictionaries.dataTypes
			if (datas) {
				var i = datas.map((d) => d.id).indexOf(value)
				if (-1 < i) {
					var c = datas[i].caption
					return c
				}
			}
			return value
		})
	}

	public getColumnForDataType(dataTypes: number[], entityType: number): ng.IPromise<ColumnModel[]> {
		var columns: ColumnModel[] = []

		dataTypes.forEach((dt) => {
			let column = new ColumnModel()
			column.id = dt
			columns.push(column)
		})

		return this.getColumnsWithNames(columns, entityType)
	}

	public getDataTypes(idDatatypes: number[]): ng.IPromise<ColumnModel[]> {
		return this.getPromise().then((dictionaries) => {
			var columns: ColumnModel[] = []
			idDatatypes.forEach((id) => {
				var dataType = dictionaries.dataTypes[id]
				if (dataType) columns.push(this.dataTypeToColumn(id, dataType))
			})
			return columns
		})
	}

	public getDataTypesSync(idDatatypes: number[]): ColumnModel[] {
		var columns: ColumnModel[] = []
		idDatatypes.forEach((id) => {
			var dataType = LocalDictionaryFactory.dictionaries.dataTypes[id]
			if (dataType) columns.push(this.dataTypeToColumn(id, dataType))
		})
		return columns
	}

	public getDataTypeSync(idDataType: number): DataTypeModel {
		var columns: ColumnModel[] = []
		return LocalDictionaryFactory.dictionaries.dataTypes[idDataType]
	}

	public getActiveViewColumnsForReferenceType(idReferenceType: number): ng.IPromise<ColumnModel[]> {
		switch (idReferenceType) {
			case CommonHelper.IdAction:
				return this.getActionDefaultPopupColumns().then((columns) => {
					if (!columns || columns.length == 0) {
						return this.getActionDefaultColumns().then((columns) => {
							if (columns && columns.length > 0) {
								return columns
							} else {
								return this.getColumnForDataType([], -1)
							}
						})
					} else {
						return columns
					}
				})

			case CommonHelper.IdActor:
				return this.getActorDisplayFields().then((columns) => {
					if (!columns || columns.length == 0) {
						return this.getActorDisplayFields().then((columns) => {
							if (columns && columns.length > 0) {
								return columns
							} else {
								return this.getColumnForDataType([], -1)
							}
						})
					} else {
						return columns
					}
				})

			case CommonHelper.IdAlarmEvent:
				return this.getAlarmsDefaultPopupColumns().then((columns) => {
					if (!columns || columns.length == 0) {
						return this.getAlarmsDefaultColumns().then((columns) => {
							if (columns && columns.length > 0) {
								return columns
							} else {
								return this.getColumnForDataType([], -1)
							}
						})
					} else {
						return columns
					}
				})

			case CommonHelper.IdAlarmGroup:
				return this.getAlarmGroupsDefaultPopupColumns().then((columns) => {
					if (!columns || columns.length == 0) {
						return this.getAlarmGroupsDefaultColumns().then((columns) => {
							if (columns && columns.length > 0) {
								return columns
							}

							return this.getColumnForDataType([Enums.DataType.HELPER_NAME], -1)
						})
					}

					return columns
				})

			case CommonHelper.IdDevice:
				return this.getDevicesDefaultPopupColumns().then((columns) => {
					if (!columns || columns.length == 0) {
						return this.getDevicesDefaultColumns().then((columns) => {
							if (columns && columns.length > 0) {
								return columns
							} else {
								return this.getColumnForDataType([], -1)
							}
						})
					} else {
						return columns
					}
				})

			case CommonHelper.IdDeviceConnection:
				return this.getDeviceConnectionsDefaultPopupColumns().then((columns) => {
					if (!columns || columns.length == 0) {
						return this.getDeviceConnectionsDefaultColumns().then((columns) => {
							if (columns && columns.length > 0) {
								return columns
							} else {
								return this.getColumnForDataType([], -1)
							}
						})
					} else {
						return columns
					}
				})

			case CommonHelper.IdDistributor:
				return this.getDistributorDefaultPopupColumns().then((columns) => {
					if (!columns || columns.length == 0) {
						return this.getDistributorDefaultColumns().then((columns) => {
							if (columns && columns.length > 0) {
								return columns
							} else {
								return this.getColumnForDataType([], -1)
							}
						})
					} else {
						return columns
					}
				})

			case CommonHelper.IdIssue:
				return this.getIssuesDefaultPopupColumns().then((columns) => {
					if (!columns || columns.length == 0) {
						return this.getIssuesDefaultColumns().then((columns) => {
							if (columns && columns.length > 0) {
								return columns
							} else {
								return this.getColumnForDataType([], -1)
							}
						})
					} else {
						return columns
					}
				})

			case CommonHelper.IdLocation:
				return this.getLocationDefaultPopupColumns().then((columns) => {
					if (!columns || columns.length == 0) {
						return this.getLocationDefaultColumns().then((columns) => {
							if (columns && columns.length > 0) {
								return columns
							} else {
								return this.getColumnForDataType([], -1)
							}
						})
					} else {
						return columns
					}
				})

			case CommonHelper.IdMeter:
				return this.getMeterDefaultPopupColumns().then((columns) => {
					if (!columns || columns.length == 0) {
						return this.getMeterDefaultColumns().then((columns) => {
							if (columns && columns.length > 0) {
								return columns
							} else {
								return this.getColumnForDataType([], -1)
							}
						})
					} else {
						return columns
					}
				})

			case CommonHelper.IdOperator:
				return this.getUserDefaultPopupColumns().then((columns) => {
					if (!columns || columns.length == 0) {
						return this.getUserDefaultColumns().then((columns) => {
							if (columns && columns.length > 0) {
								return columns
							} else {
								return this.getColumnForDataType([], -1)
							}
						})
					} else {
						return columns
					}
				})

			case Enums.ReferenceType.IdOperatorGroup:
				return this.getOperatorGroupDefaultPopupColumns().then((columns) => {
					if (!columns || columns.length == 0) {
						return this.getOperatorGroupDefaultColumns().then((columns) => {
							if (columns && columns.length > 0) {
								return columns
							} else {
								return this.getColumnForDataType([], -1)
							}
						})
					} else {
						return columns
					}
				})

			case CommonHelper.IdReport:
				return this.getReportsDefaultPopupColumns().then((columns) => {
					if (!columns || columns.length == 0) {
						return this.getReportsDefaultColumns().then((columns) => {
							if (columns && columns.length > 0) {
								return columns
							} else {
								return this.getColumnForDataType([], -1)
							}
						})
					} else {
						return columns
					}
				})

			case CommonHelper.IdRoute:
				return this.getRoutesDefaultPopupColumns().then((columns) => {
					if (!columns || columns.length == 0) {
						return this.getRoutesDefaultColumns().then((columns) => {
							if (columns && columns.length > 0) {
								return columns
							} else {
								return this.getColumnForDataType([], -1)
							}
						})
					} else {
						return columns
					}
				})

			case CommonHelper.IdSimCard:
				return this.getSimcardsDefaultPopupColumns().then((columns) => {
					if (!columns || columns.length == 0) {
						return this.getSimcardsDefaultColumns().then((columns) => {
							if (columns && columns.length > 0) {
								return columns
							} else {
								return this.getColumnForDataType([], -1)
							}
						})
					} else {
						return columns
					}
				})

			case CommonHelper.IdTariff:
				return this.getColumnForDataType([], -1)

			case CommonHelper.IdTask:
				return this.getTasksDefaultPopupColumns().then((columns) => {
					if (!columns || columns.length == 0) {
						return this.getTasksDefaultColumns().then((columns) => {
							if (columns && columns.length > 0) {
								return columns
							} else {
								return this.getColumnForDataType([], -1)
							}
						})
					} else {
						return columns
					}
				})

			case CommonHelper.IdTaskGroup:
				return this.getColumnForDataType([], -1)

			default:
				return this.getColumnForDataType([], -1)
		}
	}

	// Data types
	public getDataTypeColumns(): ng.IPromise<ColumnModel[]> {
		return this.getPromise().then(() => {
			const columns = []
			columns.push({ id: 0, idName: 'name', name: 'Name', caption: i18n('Common', 'Name') })
			columns.push({ id: 1, idName: 'id', name: 'Id', caption: i18n('Common', 'Id'), hidden: true })

			return columns
		})
	}

	// Location
	public getLocationColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_LOCATION_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdLocation)
		})
	}

	public getLocationDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_LOCATION_DEFAULT_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdLocation)
		})
	}

	public getLocationDefaultPopupColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_LOCATION_POPUP_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdLocation)
		})
	}

	public getLocationDeviceDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_LOCATION_DEVICE_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdDevice)
		})
	}

	public getLocationMeterDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_LOCATION_METER_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdMeter)
		})
	}

	public getLocationSelectColumns(): ng.IPromise<ColumnModel[]> {
		return this.getPromise().then(() => {
			var columns = []
			columns.push({ id: 1, idName: 'name', name: 'Name', caption: i18n('Common', 'Name') })

			return this.getColumnsWithNames(columns, CommonHelper.IdLocation)
		})
	}

	public getLocationDisplayFields(referenceValue: number): ng.IPromise<any[]> {
		return this.getDictionary('WEBSIMAX_LOCATION_PANEL_PARAMS_TO_DISPLAY', CommonHelper.IdDistributor, referenceValue)
	}

	public getLocationEditFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		if (referenceValue == null) {
			referenceValue = this.api.login.getUser().idDistributor
		}
		return this.getDictionary('WEBSIMAX_LOCATION_PANEL_PARAMS_TO_EDIT', CommonHelper.IdDistributor, referenceValue)
	}

	public getLocationImportParams(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_LOCATION_IMPORT_PARAMS')
	}

	public getLocationRequiredFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		if (referenceValue == null) {
			referenceValue = this.api.login.getUser().idDistributor
		}
		return this.getDictionary('WEBSIMAX_LOCATION_PARAMS_REQUIRED', CommonHelper.IdDistributor, referenceValue).then((columns) => {
			return columns
		})
	}

	public getLocationGridDisplayFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_LOCATION_GRID_PARAMS_TO_DISPLAY', CommonHelper.IdDistributor, referenceValue)
	}

	public getLocationPreviewFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_LOCATION_PREVIEW_PANEL_PARAMS', CommonHelper.IdDistributor, referenceValue).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdLocation)
		})
	}

	public getLocationGridEditFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_LOCATION_GRID_PARAMS_TO_EDIT', CommonHelper.IdDistributor, referenceValue)
	}

	// Depository
	public getDepositoriesColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DEPOSITORY_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdLocation)
		})
	}

	public getDepositoriesDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DEPOSITORY_DEFAULT_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdLocation)
		})
	}

	// Device Connections
	public getDeviceConnectionsColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DEVICE_CONNECTION_GRID_PARAMS', CommonHelper.IdDeviceConnection, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdDeviceConnection)
		})
	}

	public getDeviceConnectionsDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DEVICE_CONNECTION_DEFAULT_GRID_PARAMS', CommonHelper.IdDeviceConnection, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdDeviceConnection)
		})
	}

	public getDeviceConnectionsDefaultPopupColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DEVICE_CONNECTION_POPUP_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdDeviceConnection)
		})
	}

	public getDeviceConnectionsPreviewFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DEVICE_CONNECTION_PREVIEW_PANEL_PARAMS', CommonHelper.IdDeviceConnection, referenceValue).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdDeviceConnection)
		})
	}

	// Device
	public getDevicesHierarchyColumns(): JQueryPromise<ColumnModel[]> {
		var deferred = $.Deferred<ColumnModel[]>()

		var columns = []
		columns.push({ id: 'device', caption: i18n('Common', 'Device') })
		columns.push({ id: 'slotNbr', caption: i18n('Common', 'SlotNbr') })
		columns.push({ id: 'slotType', caption: i18n('Common', 'SlotType') })
		columns.push({ id: 'protocolIn', caption: i18n('Common', 'ProtocolIn') })
		columns.push({ id: 'protocolOut', caption: i18n('Common', 'ProtocolOut') })
		columns.push({ id: 'active', caption: i18n('Common', 'Active'), type: 7 })

		deferred.resolve(columns)

		return deferred.promise()
	}

	public getDevicesColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DEVICE_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdDevice)
		})
	}

	public getDevicesDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DEVICE_DEFAULT_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdDevice)
		})
	}

	public getDevicesDefaultPopupColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DEVICE_POPUP_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdDevice)
		})
	}

	public getDeviceDisplayFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DEVICE_PANEL_PARAMS_TO_DISPLAY', CommonHelper.IdDeviceType, referenceValue).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdDevice)
		})
	}

	public getDeviceEditFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DEVICE_PANEL_PARAMS_TO_EDIT', CommonHelper.IdDeviceType, referenceValue)
	}

	public getDeviceRequiredFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DEVICE_PARAMS_REQUIRED', CommonHelper.IdDeviceType, referenceValue)
	}

	public getDeviceImportParams(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DEVICE_IMPORT_PARAMS')
	}

	public getDeviceGridDisplayFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DEVICE_GRID_PARAMS_TO_DISPLAY', CommonHelper.IdDeviceType, referenceValue)
	}

	public getDeviceGridEditFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DEVICE_GRID_PARAMS_TO_EDIT', CommonHelper.IdDeviceType, referenceValue)
	}

	public getDevicePreviewFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DEVICE_PREVIEW_PANEL_PARAMS', CommonHelper.IdDeviceType, referenceValue).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdDevice)
		})
	}

	//Route
	public getRoutesColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ROUTE_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdRoute)
		})
	}
	public getRoutesDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ROUTE_DEFAULT_GRID_PARAMS').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdRoute)
		})
	}

	public getRoutesDefaultPopupColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ROUTE_POPUP_GRID_PARAMS').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdRoute)
		})
	}

	public getRouteDisplayFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ROUTE_PANEL_PARAMS_TO_DISPLAY')
	}

	public getRouteEditFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ROUTE_PANEL_PARAMS_TO_EDIT')
	}

	public getRouteRequiredFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ROUTE_PARAMS_REQUIRED')
	}

	public getRoutePointColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ROUTE_TASK_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdTask)
		})
	}

	public getRouteImportParams(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ROUTE_IMPORT_PARAMS')
	}

	public getRoutePointColumnsEdit(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ROUTE_LOCATION_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdLocation)
		})
	}
	public getRouteOperatorsColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ROUTE_OPERATOR_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdOperator)
		})
	}

	// Meter
	public getMeterColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_METER_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdMeter)
		})
	}

	public getMeterDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_METER_DEFAULT_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdMeter)
		})
	}

	public getMeterDefaultPopupColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_METER_POPUP_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdMeter)
		})
	}

	public getMeterDeviceColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_METER_DEVICE_GRID_PARAMS').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdDevice)
		})
	}

	public getMeterDisplayFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_METER_PANEL_PARAMS_TO_DISPLAY', CommonHelper.IdMeterTypeClass, referenceValue)
	}

	public getMeterEditFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_METER_PANEL_PARAMS_TO_EDIT', CommonHelper.IdMeterTypeClass, referenceValue)
	}

	public getMeterRequiredFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_METER_PARAMS_REQUIRED', CommonHelper.IdMeterTypeClass, referenceValue)
	}

	public getMeterImportParams(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_METER_IMPORT_PARAMS')
	}

	public getMeterPreviewFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_METER_PREVIEW_PANEL_PARAMS', CommonHelper.IdMeterTypeClass, referenceValue).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdMeter)
		})
	}

	public getMeterGridDisplayFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_METER_GRID_PARAMS_TO_DISPLAY', CommonHelper.IdMeterTypeClass, referenceValue)
	}

	public getMeterGridEditFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_METER_GRID_PARAMS_TO_EDIT', CommonHelper.IdMeterTypeClass, referenceValue)
	}

	public getMeterAlarmDefFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_METER_ALARM_DEF_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor)
	}

	public getMeterAlarmDefRefsFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_METER_ALARM_DEF_REF_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor)
	}

	public getMeterAlarmDefTypesFields(referenceValue): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_METER_ALARM_DEF_PARAMS', CommonHelper.IdAlarmType, referenceValue)
	}

	public getMeterAlarmDefPanelFields(referenceValue): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_METER_ALARM_DEF_PANEL_PARAMS', CommonHelper.IdMeterTypeClass, referenceValue)
	}

	// Measurement
	public getChartTypes() {
		return this.$q
			.all(
				[
					ChartType.Line,
					ChartType.Bar,
					ChartType.StackedBar,
					ChartType.StepArea,
					ChartType.StepLine,
					ChartType.Area,
					ChartType.StackedLine,
					ChartType.StackedSpline,
					ChartType.StackedArea,
					ChartType.StackedSplineArea,
					ChartType.FullStackedLine,
					ChartType.FullStackedArea,
					ChartType.FullStackedBar,
					ChartType.FullStackedSpline,
					ChartType.FullStackedSplineArea,
					ChartType.Pie,
					ChartType.Doughnut,
				].map((id) => this.getDictionary('WEBSIMAX_DATA_TYPE_CHART_TYPE', CommonHelper.IdChartType, id))
			)
			.then((result) => {
				var [
					ChartTypeLine,
					ChartTypeBar,
					ChartTypeStackedBar,
					ChartTypeStepArea,
					ChartTypeStepLine,
					ChartTypeArea,
					ChartTypeStackedLine,
					ChartTypeStackedSpline,
					ChartTypeStackedArea,
					ChartTypeStackedSplineArea,
					ChartTypeFullStackedLine,
					ChartTypeFullStackedArea,
					ChartTypeFullStackedBar,
					ChartTypeFullStackedSpline,
					ChartTypeFullStackedSplineArea,
					ChartTypePie,
					ChartTypeDoughnut,
				] = result
				return [
					{ name: 'line', dataTypes: ChartTypeLine },
					{ name: 'bar', dataTypes: ChartTypeBar },
					{ name: 'stackedbar', dataTypes: ChartTypeStackedBar },
					{ name: 'steparea', dataTypes: ChartTypeStepArea },
					{ name: 'stepline', dataTypes: ChartTypeStepLine },
					{ name: 'area', dataTypes: ChartTypeArea },
					{ name: 'stackedline', dataTypes: ChartTypeStackedLine },
					{ name: 'stackedspline', dataTypes: ChartTypeStackedSpline },
					{ name: 'stackedarea', dataTypes: ChartTypeStackedArea },
					{ name: 'stackedsplinearea', dataTypes: ChartTypeStackedSplineArea },
					{ name: 'fullstackedline', dataTypes: ChartTypeFullStackedLine },
					{ name: 'fullstackedarea', dataTypes: ChartTypeFullStackedArea },
					{ name: 'fullstackedbar', dataTypes: ChartTypeFullStackedBar },
					{ name: 'fullstackedspline', dataTypes: ChartTypeFullStackedSpline },
					{ name: 'fullstackedsplinearea', dataTypes: ChartTypeFullStackedSplineArea },
					{ name: 'pie', dataTypes: ChartTypePie },
					{ name: 'doughnut', dataTypes: ChartTypeDoughnut },
				]
			})
	}

	public getChartTypeForDataType(idDataType: number) {
		return this.getChartTypes().then((chartTypes) => {
			chartTypes.forEach((type) => {
				if (
					type.dataTypes.some((dt) => {
						return dt.id == idDataType
					})
				)
					return type.name
			})
			return 'line'
		})
	}

	private updateFieldsByChartTypes(chartTypes: { name: string; dataTypes: ColumnModel[] }[], fields: ColumnModel[]) {
		fields.forEach((f) => {
			f.chartType = 'line'

			chartTypes.some((chartType) => {
				return chartType.dataTypes.some((c) => {
					if (f.id == c.id) {
						f.chartType = chartType.name
						return true
					}
					return false
				})
			})
		})

		return fields
	}

	public getMeasurementsForLocationFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getChartTypes().then((result) => {
			return this.getDictionary('WEBSIMAX_LOCATION_MEASUREMENTS', CommonHelper.IdDistributor, referenceValue).then((fields) => {
				return this.updateFieldsByChartTypes(result, fields)
			})
		})
	}

	public getLPGKPIParams(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getChartTypes().then((result) => {
			return this.getDictionary('WEBSIMAX_LPG_KPI_KPI_PARAMS', CommonHelper.IdDistributor, referenceValue).then((fields) => {
				return this.updateFieldsByChartTypes(result, fields)
			})
		})
	}

	private getDictKPI(referenceType: number, pageSize: number, pageNumber: number, where?: string): ng.IPromise<GridModel> {
		let deferred = this.$q.defer<GridModel>()
		this.getActiveViewColumnsForReferenceType(referenceType)
			.then((columns) => {
				let grm = new GridRequestModel()
				grm.columns = columns
				grm.pageSize = pageSize
				grm.pageNumber = pageNumber
				grm.where = where
				switch (referenceType) {
					case CommonHelper.IdMeter:
						this.api.kpi.getMeters(grm).then((result) => {
							deferred.resolve(result)
						})
						break
					case CommonHelper.IdLocation:
						this.api.kpi.getLocations(grm).then((result) => {
							deferred.resolve(result)
						})
						break
				}
			})
			.catch((reason) => {
				this.logger.log(reason)
				CommonHelper.openInfoPopup(i18n('Common', 'DictionariesProblem'), 'error', 3000)
			})
		return deferred.promise
	}

	public getMetersKPI(pageSize: number, pageNumber: number, where?: string): ng.IPromise<GridModel> {
		return this.getDictKPI(CommonHelper.IdMeter, pageSize, pageNumber, where)
	}

	public getLocationsKPI(pageSize: number, pageNumber: number, where?: string): ng.IPromise<GridModel> {
		return this.getDictKPI(CommonHelper.IdLocation, pageSize, pageNumber, where)
	}

	public getMeasurementsForDeviceFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getChartTypes().then((result) => {
			return this.getDictionary('WEBSIMAX_DEVICE_MEASUREMENTS', CommonHelper.IdDeviceType, referenceValue).then((fields) => {
				return this.updateFieldsByChartTypes(result, fields)
			})
		})
	}

	public getMeasurementsForMeterFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getChartTypes().then((result) => {
			return this.getDictionary('WEBSIMAX_METER_MEASUREMENTS', CommonHelper.IdMeterTypeClass, referenceValue).then((fields) => {
				return this.updateFieldsByChartTypes(result, fields)
			})
		})
	}

	public getMeasurementsDataTypesFilterColumns(): JQueryPromise<ColumnModel[]> {
		var deferred = $.Deferred<ColumnModel[]>()

		var columns = []
		columns.push({ id: 1, idName: 'name', name: 'Name', caption: i18n('Common', 'Name') })
		deferred.resolve(columns)

		return deferred.promise()
	}

	// User
	public getUserColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_OPERATOR_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdOperator)
		})
	}

	public getUserDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_OPERATOR_DEFAULT_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdOperator)
		})
	}

	public getUserDisplayFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_OPERATOR_PANEL_PARAMS_TO_DISPLAY')
	}

	public getUserActorDisplayFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ACTOR_PANEL_PARAMS_TO_DISPLAY')
	}

	public getUserDefaultPopupColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_OPERATOR_POPUP_GRID_PARAMS').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdOperator)
		})
	}

	public getUserEditFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_OPERATOR_PANEL_PARAMS_TO_EDIT')
	}

	public getUserRequiredFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_OPERATOR_PARAMS_REQUIRED')
	}

	public getUserImportParams(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_OPERATOR_IMPORT_PARAMS')
	}

	public getUserSelectColumns(): ng.IPromise<ColumnModel[]> {
		return this.getPromise().then(() => {
			var columns = []
			columns.push({ id: CommonHelper.userColumnId, idName: 'name', name: 'Name', caption: i18n('Common', 'Name') })
			return this.getColumnsWithNames(columns, CommonHelper.IdOperator)
		})
	}

	//Operator Group
	public getOperatorGroupDefaultPopupColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_OPERATOR_GROUP_POPUP_GRID_PARAMS').then((columns) => {
			return this.getColumnsWithNames(columns, Enums.ReferenceType.IdOperatorGroup)
		})
	}

	public getOperatorGroupDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_OPERATOR_GROUP_DEFAULT_GRID_PARAMS').then((columns) => {
			return this.getColumnsWithNames(columns, Enums.ReferenceType.IdOperatorGroup)
		})
	}

	// Actor
	public getActorDisplayFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ACTOR_PANEL_PARAMS_TO_DISPLAY').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdActor)
		})
	}

	public getActorEditFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ACTOR_PANEL_PARAMS_TO_EDIT')
	}

	public getActorRequiredFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ACTOR_PARAMS_REQUIRED')
	}

	public getActorSelectColumns(): ng.IPromise<ColumnModel[]> {
		return this.getPromise().then(() => {
			var columns = []
			columns.push({ id: CommonHelper.actorColumnId, idName: 'name', name: 'Name', caption: i18n('Common', 'Name') })
			return this.getColumnsWithNames(columns, CommonHelper.IdActor)
		})
	}

	// Issues
	public getIssuesColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ISSUE_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdIssue)
		})
	}

	public getIssuesDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ISSUE_DEFAULT_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdIssue)
		})
	}

	public getIssuesDefaultPopupColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ISSUE_POPUP_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdIssue)
		})
	}

	public getIssueTaskDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ISSUE_TASK_GRID_PARAMS').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdTask)
		})
	}

	public getIssueDisplayFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ISSUE_PANEL_PARAMS_TO_DISPLAY').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdIssue)
		})
	}

	public getIssueImportParams(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ISSUE_IMPORT_PARAMS')
	}

	public getIssueEditFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ISSUE_PANEL_PARAMS_TO_EDIT')
	}

	public getIssueRequiredFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ISSUE_PARAMS_REQUIRED')
	}

	// Tasks
	public getTasksColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_TASK_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdTask)
		})
	}

	public getTasksDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_TASK_DEFAULT_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdTask)
		})
	}

	public getTasksDefaultPopupColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_TASK_POPUP_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdTask)
		})
	}

	public getTaskDisplayFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_TASK_PANEL_PARAMS_TO_DISPLAY')
	}

	public getTaskEditFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_TASK_PANEL_PARAMS_TO_EDIT')
	}

	public getTaskImportParams(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_TASK_IMPORT_PARAMS')
	}

	public getTaskRequiredFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_TASK_PARAMS_REQUIRED')
	}

	public getTaskInstalledDevicesColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_TASK_INSTALLED_DEVICES_GRID_PARAMS')
	}

	public getTaskUninstalledDevicesColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_TASK_UNINSTALLED_DEVICES_GRID_PARAMS')
	}

	public getTaskGroupSelectColumns(): ng.IPromise<ColumnModel[]> {
		return this.getPromise().then(() => {
			var columns = []
			columns.push({ id: CommonHelper.taskGroupColumnId, idName: 'name', name: 'Name', caption: i18n('Common', 'Name') })
			return this.getColumnsWithNames(columns, CommonHelper.IdTaskGroup)
		})
	}

	//Alarms
	public getAlarmsColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ALARM_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdAlarmEvent)
		})
	}

	public getAlarmsDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ALARM_DEFAULT_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdAlarmEvent)
		})
	}

	public getAlarmsDefaultPopupColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ALARM_POPUP_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdAlarmEvent)
		})
	}

	public getAlarmDisplayFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ALARM_PANEL_PARAMS_TO_DISPLAY', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdAlarmEvent)
		})
	}

	public getAlarmEditFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ALARM_PANEL_PARAMS_TO_EDIT', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor)
	}

	public getAlarmRequiredFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ALARM_PARAMS_REQUIRED')
	}

	// Alarm Groups
	public getAlarmGroupsColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ALARM_GROUP_GRID_PARAMS').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdAlarmGroup)
		})
	}

	public getAlarmGroupsDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ALARM_GROUP_DEFAULT_GRID_PARAMS').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdAlarmGroup)
		})
	}

	public getAlarmGroupsDefaultPopupColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ALARM_GROUPS_POPUP_GRID_PARAMS').then((columns: ColumnModel[]) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdDistributor)
		})
	}

	public getAlarmGroupsDisplayFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ALARM_GROUP_PANEL_PARAMS_TO_DISPLAY')
	}

	public getAlarmGroupsEditFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ALARM_GROUP_PANEL_PARAMS_TO_EDIT')
	}

	public getAlarmGroupsRequiredFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ALARM_GROUP_PARAMS_REQUIRED')
	}

	public getAlarmGroupOperatorsColumns(): ng.IPromise<ColumnModel[]> {
		return this.getPromise().then(() => {
			var columns = []
			columns.push({ id: 1, idName: 'name', name: 'Name', caption: i18n('Common', 'Operator') })
			return columns
		})
	}

	// Distributors
	public getDistributorDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DISTRIBUTOR_DEFAULT_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdDistributor)
		})
	}

	public getDistributorDefaultPopupColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DISTRIBUTOR_POPUP_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdDistributor)
		})
	}

	public getDistributorColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DISTRIBUTOR_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdDistributor)
		})
	}

	public getDistributorDisplayFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DISTRIBUTOR_PANEL_PARAMS_TO_DISPLAY', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdDistributor)
		})
	}

	public getDistributorEditFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DISTRIBUTOR_PANEL_PARAMS_TO_EDIT', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor)
	}

	public getDistributorRequiredFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DISTRIBUTOR_PARAMS_REQUIRED', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor)
	}

	//Contact
	public getContactColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ACTOR_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdActor)
		})
	}
	public getContactDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ACTOR_DEFAULT_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdActor)
		})
	}
	public getContactGroupsColumns(): ng.IPromise<ColumnModel[]> {
		return this.getPromise().then(() => {
			var columns = []
			columns.push({ id: 1, idName: 'name', name: 'Name', caption: i18n('Common', 'Name') })
			columns.push({ id: 2, idName: 'distributor', name: 'Distributor', caption: i18n('Common', 'Distributor') })
			columns.push({ id: 3, idName: 'builtin', name: 'BuiltIn', caption: i18n('Common', 'BuiltIn'), type: 7 })

			return columns
		})
	}
	public getContactDisplayFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ACTOR_PANEL_PARAMS_TO_DISPLAY')
	}
	public getContactEditFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ACTOR_PANEL_PARAMS_TO_EDIT')
	}
	public getContactRequiredFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ACTOR_PARAMS_REQUIRED')
	}
	public getContactLocationColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ACTOR_LOCATION_GRID_PARAMS').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdLocation)
		})
	}
	public getContactLocationColumnsEdit(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ACTOR_LOCATION_GRID_PARAMS').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdLocation)
		})
	}

	//Sim cards
	public getSimcardsColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_SIM_CARD_GRID_PARAMS').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdSimCard)
		})
	}
	public getSimcardsDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_SIM_CARD_DEFAULT_GRID_PARAMS').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdSimCard)
		})
	}

	public getSimcardsDefaultPopupColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_SIM_CARD_POPUP_GRID_PARAMS').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdSimCard)
		})
	}

	public getSimcardsDisplayFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_SIM_CARD_PANEL_PARAMS_TO_DISPLAY').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdSimCard)
		})
	}
	public getSimcardsEditFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_SIM_CARD_PANEL_PARAMS_TO_EDIT').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdSimCard)
		})
	}
	public getSimcardsRequiredFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_SIM_CARD_PARAMS_REQUIRED').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdSimCard)
		})
	}

	public getSimcardImportParams(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_SIM_CARD_IMPORT_PARAMS')
	}

	public getSimcardTariffSelectColumns(): ng.IPromise<ColumnModel[]> {
		return this.getPromise().then(() => {
			var columns = []
			columns.push({ id: CommonHelper.simcardTariffColumnId, idName: 'name', name: 'Name', caption: i18n('Common', 'Name') })
			return this.getColumnsWithNames(columns, CommonHelper.IdSimCard)
		})
	}

	public getSimcardOperatorTariffSelectColumns(): ng.IPromise<ColumnModel[]> {
		return this.getPromise().then(() => {
			var columns = []
			columns.push({ id: CommonHelper.simcardOperatorTariffColumnId, idName: 'name', name: 'Name', caption: i18n('Common', 'Name') })
			return this.getColumnsWithNames(columns, CommonHelper.IdSimCard)
		})
	}

	// Actions
	public getActionColumns(parentElementId: number = undefined): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ACTION_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			var addParentElementCol = true
			if (parentElementId) {
				columns.forEach((column) => {
					if (column.id == parentElementId) {
						addParentElementCol = false
					}
				})
				if (addParentElementCol) {
					var parentElementCol = new ColumnModel()
					parentElementCol.id = parentElementId
					columns.push(parentElementCol)
				}
			}
			return this.getColumnsWithNames(columns, CommonHelper.IdAction)
		})
	}
	public getActionDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ACTION_DEFAULT_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdAction)
		})
	}

	public getActionDefaultPopupColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ACTION_POPUP_GRID_PARAMS', CommonHelper.IdDistributor, this.api.login.getUser().idDistributor).then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdAction)
		})
	}

	public getActionDisplayFields(referenceValue: number): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_ACTION_PANEL_PARAMS_TO_DISPLAY', CommonHelper.IdAction, referenceValue)
	}

	public getActionDevicesAnswerColumns(): JQueryPromise<ColumnModel[]> {
		var deferred = $.Deferred<ColumnModel[]>()

		var columns = []
		columns.push({ id: 'address', caption: i18n('Common', 'Address') })
		columns.push({
			id: 'direction',
			caption: i18n('Common', 'Direction'),
			lookup: {
				dataSource: [
					{ id: 1, format: i18n('Common', 'Incoming') },
					{ id: 2, format: i18n('Common', 'Outgoing') },
				],
				valueExpr: 'id',
				displayExpr: 'format',
			},
		})
		columns.push({ id: 'packetTime', caption: i18n('Common', 'PacketTime'), type: 6 })
		columns.push({ id: 'serialNumber', caption: i18n('Common', 'SerialNumber') })
		columns.push({ id: 'transmissionDriver', caption: i18n('Common', 'TransmissionDriver') })
		columns.push({ id: 'status', caption: i18n('Common', 'Status') })

		deferred.resolve(columns)

		return deferred.promise()
	}

	// Reports
	public getReportsColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_REPORT_GRID_PARAMS').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdReport)
		})
	}

	public getReportsDefaultColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_REPORT_DEFAULT_GRID_PARAMS').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdReport)
		})
	}

	public getReportsDefaultPopupColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_REPORT_POPUP_GRID_PARAMS').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdReport)
		})
	}

	public getReportsDisplayFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_REPORT_PANEL_PARAMS_TO_DISPLAY').then((columns) => {
			return this.getColumnsWithNames(columns, CommonHelper.IdReport)
		})
	}

	public getReportsEditFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_REPORT_PANEL_PARAMS_TO_EDIT')
	}

	public getReportsRequiredFields(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_REPORT_PARAMS_REQUIRED')
	}

	// Servicemans
	public geServicemansColumns(): ng.IPromise<ColumnModel[]> {
		return this.getPromise().then(() => {
			var columns = []
			columns.push({ id: 1, idName: 'name', name: 'Name', caption: i18n('Common', 'Name') })
			return columns
		})
	}

	// Others
	public getDistributorHierarchy(): ng.IPromise<OpDistributorHierarchy[]> {
		return this.getFieldFromDictionary('references').then((references) => {
			return references[CommonHelper.IdDistributorHierarchy]
		})
	}

	public getActivityColumns(): JQueryPromise<ColumnModel[]> {
		var deferred = $.Deferred<ColumnModel[]>()

		var columns = []
		columns.push({ id: 'description', type: CommonHelper.text, caption: i18n('Popup', 'Description') })
		columns.push({ id: 'allow', type: CommonHelper.boolean, caption: i18n('Popup', 'Allow') })
		columns.push({ id: 'referenceType', type: CommonHelper.text, caption: i18n('Popup', 'ReferenceType') })
		columns.push({ id: 'referenceObject', type: CommonHelper.text, caption: i18n('Popup', 'ReferenceObject') })

		deferred.resolve(columns)
		return deferred.promise()
	}

	public getActivityColumnsShort(): JQueryPromise<ColumnModel[]> {
		var deferred = $.Deferred<ColumnModel[]>()

		var columns = []
		columns.push({ id: 'description', type: CommonHelper.text, caption: i18n('Popup', 'Description') })
		columns.push({ id: 'allow', type: CommonHelper.boolean, caption: i18n('Popup', 'Allow') })

		deferred.resolve(columns)
		return deferred.promise()
	}

	public getAttachmentColumns(): JQueryPromise<ColumnModel[]> {
		var deferred = $.Deferred<ColumnModel[]>()

		var columns = []
		columns.push({ id: 'physicalFileName', caption: i18n('Common', 'PhysicalFileName') })
		columns.push({ id: 'size', caption: i18n('Common', 'Size'), unitName: 'Mb', type: 1 })
		columns.push({ id: 'description', caption: i18n('Common', 'Description') })
		columns.push({ id: 'insertDate', caption: i18n('Common', 'InsertDate'), type: 6 })

		deferred.resolve(columns)

		return deferred.promise()
	}

	public getLocationEquipmentColumns(): JQueryPromise<ColumnModel[]> {
		var deferred = $.Deferred<ColumnModel[]>()

		var columns = []
		columns.push({ id: 1, idName: 'Device', caption: i18n('Common', 'Device') })
		columns.push({ id: 2, idName: 'Meter', caption: i18n('Common', 'Meter') })
		columns.push({ id: 3, idName: 'StartTime', caption: i18n('Common', 'StartTime'), type: 6 })

		deferred.resolve(columns)

		return deferred.promise()
	}

	public getTaskForIssueColumns(): JQueryPromise<ColumnModel[]> {
		var deferred = $.Deferred<ColumnModel[]>()

		var columns = []
		columns.push({ id: 1, idName: 'TaskString', caption: i18n('Common', 'TaskString') })

		deferred.resolve(columns)

		return deferred.promise()
	}

	public getRoleColumns(): JQueryPromise<ColumnModel[]> {
		var deferred = $.Deferred<ColumnModel[]>()

		var columns = []
		columns.push({ id: 1, idName: 'Name', type: CommonHelper.text, caption: i18n('Popup', 'Name') })
		columns.push({ id: 2, idName: 'Description', type: CommonHelper.text, caption: i18n('Popup', 'Description') })
		columns.push({ id: 3, idName: 'ModuleName', type: CommonHelper.text, caption: i18n('Popup', 'ModuleName') })

		deferred.resolve(columns)

		return deferred.promise()
	}

	public getNotificationColumns(): JQueryPromise<ColumnModel[]> {
		var deferred = $.Deferred<ColumnModel[]>()

		var columns = []
		columns.push({ id: 1, idName: 'Action', type: CommonHelper.text, caption: i18n('Popup', 'Action') })
		columns.push({ id: 2, idName: 'NotificationByEmail', type: CommonHelper.boolean, caption: i18n('Popup', 'NotificationByEmail') })
		columns.push({ id: 3, idName: 'NotificationBySms', type: CommonHelper.boolean, caption: i18n('Popup', 'NotificationBySms') })

		deferred.resolve(columns)

		return deferred.promise()
	}

	public getPaymentsColumns(): JQueryPromise<any[]> {
		var deferred = $.Deferred<any[]>()

		var columns = []
		columns.push({ dataField: 'element', caption: i18n('Common', 'Product') })
		columns.push({ dataField: 'value', caption: i18n('Common', 'Amount'), type: 1 })
		columns.push({ dataField: 'notes', caption: i18n('Common', 'Notes'), visible: false })

		deferred.resolve(columns)
		return deferred.promise()
	}

	public getDepositoryColumns(): JQueryPromise<any[]> {
		var deferred = $.Deferred<any[]>()

		var columns = []
		columns.push({ id: CommonHelper.locationName, dataField: 'name', caption: i18n('Common', 'Name'), isEditable: true })
		columns.push({ id: CommonHelper.locationAddress, dataField: 'address', caption: i18n('Common', 'Address'), isEditable: true })

		deferred.resolve(columns)
		return deferred.promise()
	}

	public getDeviceDepositoryColumns(): ng.IPromise<ColumnModel[]> {
		return this.getDictionary('WEBSIMAX_DEPOSITORY_CONTENT_GRID_PARAMS').then((columns) => {
			if (columns.length > 0) return this.getColumnsWithNames(columns, CommonHelper.IdDevice)
			else {
				var cols = []
				cols.push({ id: DataType.HELPER_SERIAL_NBR, type: 1, caption: i18n('Common', 'SerialNbr') })
				cols.push({ id: DataType.HELPER_ID_DEVICE_TYPE, caption: i18n('Common', 'DeviceType') })
				return this.getColumnsWithNames(cols, CommonHelper.IdDevice)
			}
		})
	}

	public getIdLocationColumns(): JQueryPromise<ColumnModel[]> {
		var deferred = $.Deferred<any[]>()
		var columns = []
		columns.push({ id: 'idLocation', caption: i18n('Common', 'Location') })
		deferred.resolve(columns)
		return deferred.promise()
	}

	public getDeviceDepositoryLocationColumns(): JQueryPromise<any[]> {
		var deferred = $.Deferred<any[]>()
		var columns = []
		columns.push({ id: DataType.HELPER_SERIAL_NBR, type: 1, caption: i18n('Common', 'SerialNbr') })
		columns.push({ id: DataType.HELPER_ID_DEVICE_TYPE, caption: i18n('Common', 'DeviceType') })
		this.getColumnsWithNames(columns, CommonHelper.IdDevice).then((result) => {
			columns = result
			columns.push({ id: 'idLocation', caption: i18n('Common', 'Location') })
			deferred.resolve(columns)
		})
		return deferred.promise()
	}

	public getModules(): ng.IPromise<ColumnModel[]> {
		return this.getFieldFromDictionary('modules')
	}

	public getAllDistributors(): ng.IPromise<ColumnModel[]> {
		return this.getFieldFromDictionary('distributors')
	}

	public getUnits(): ng.IPromise<ColumnModel[]> {
		return this.getFieldFromDictionary('units')
	}

	public getIdUnitByIdDataType(id: number) {
		return this.getPromise().then((dictionaries) => {
			var dataType = dictionaries.dataTypes[id]
			if (dataType) return dataType.unitId
			return null
		})
	}

	public getCaptionByIdDataType(id: number) {
		if (LocalDictionaryFactory.dictionaries && LocalDictionaryFactory.dictionaries.dataTypes[id]) {
			return LocalDictionaryFactory.dictionaries.dataTypes[id].caption
		} else {
			return null
		}
	}

	private tryGetDictionaryContent<T extends IReferenceType>(dictionaries: Dictionary<Dictionary<IReferenceType>>, referenceType: Enums.ReferenceType) {
		if (!dictionaries || !dictionaries.containsKey(referenceType)) return null
		var dict: Dictionary<IReferenceType> = dictionaries.tryGetValue(referenceType)
		if (!dict) return null
		return <T[]>dict.values()
	}

	public refreshDictionaries(forceRefresh?: boolean): ng.IPromise<ExtendedDictionaryModel> {
		var versionDefer = this.$q.defer<number>()
		if (window['config'].USE_REST_API) {
			this.userSession
				.getDataProvider()
				.System.getDictVersion()
				.then((version) => {
					versionDefer.resolve(version)
				})
		} else {
			this.api.dictionary.getVersion().then((result) => {
				this.userSession.getDataProvider().setDataProviderContext(null, null, result.value)
				versionDefer.resolve(result.value)
			})
		}

		var dictionariesInfo = this.getDictionariesInfo()

		var promise = versionDefer.promise
			.then((version) => {
				this.version = version
				var locale = this.userSession.getDataProvider().System.getCurrentLanguage()
				this.locale = locale
				var userId = this.api.login.getUser().id
				this.operatorId = userId

				if (!dictionariesInfo || locale != dictionariesInfo.locale || dictionariesInfo.version != version || userId != dictionariesInfo.user || forceRefresh) {
					var dictionariesDefer = this.$q.defer<ExtendedDictionaryModel>()

					if (window['config'].USE_REST_API) {
						var baseDictionariesToGet: Enums.ReferenceType[] = []
						baseDictionariesToGet.push(Enums.ReferenceType.IdDataTypeClass)
						baseDictionariesToGet.push(Enums.ReferenceType.IdDataTypeFormat)
						baseDictionariesToGet.push(Enums.ReferenceType.IdReferenceType)
						baseDictionariesToGet.push(Enums.ReferenceType.IdUnit)
						baseDictionariesToGet.push(Enums.ReferenceType.IdDataType)
						baseDictionariesToGet.push(Enums.ReferenceType.IdDataTypeGroup)
						baseDictionariesToGet.push(Enums.ReferenceType.IdDataTypeInGroup)
						baseDictionariesToGet.push(Enums.ReferenceType.IdModule)
						baseDictionariesToGet.push(Enums.ReferenceType.IdDistributor)

						// Nie ładuje się w create edit
						baseDictionariesToGet.push(Enums.ReferenceType.IdUniversalDigitalInputConfiguration)

						this.userSession
							.getDataProvider()
							.System.getDictionaries(baseDictionariesToGet, forceRefresh)
							.then((result) => {
								//DataProvider.getBaseDictionaries().then(result => {

								var dictionaries = <ExtendedDictionaryModel>{
									dataTypes: {},
									dataTypeGroups: this.tryGetDictionaryContent<OpDataTypeGroup>(result, Enums.ReferenceType.IdDataTypeGroup), //<any[]>result.dataTypeGroups,
									dataTypeInGroups: {},
									referenceIds: CommonHelper.distinct<number>(this.tryGetDictionaryContent<OpDataType>(result, Enums.ReferenceType.IdDataType).map((d) => d.idReferenceType)).filter(
										(idDataType) => idDataType != null
									),
									modules: this.tryGetDictionaryContent<OpModule>(result, Enums.ReferenceType.IdModule).map((module) => {
										//result.modules.map(module => {
										var model = new ColumnModel()
										model.caption = module.toString()
										model.id = module.idModule
										return model
									}),
									distributors: this.tryGetDictionaryContent<OpDistributor>(result, Enums.ReferenceType.IdDistributor).map((distributor) => {
										//result.distributors.map(distributor => {
										var model = new ColumnModel()
										model.caption = distributor.toString()
										model.id = distributor.idDistributor
										return model
									}),
									units: this.tryGetDictionaryContent<OpUnit>(result, Enums.ReferenceType.IdUnit).map((unit) => {
										//result.units.map(unit => {
										var model = new ColumnModel()
										model.caption = unit.toString()
										model.id = unit.idUnit
										return model
									}),
									views: {},
									references: {},
								}

								//result.dataTypes.forEach(dataType => {
								this.tryGetDictionaryContent<OpDataType>(result, Enums.ReferenceType.IdDataType).forEach((dataType) => {
									var oldModel = new DataTypeModel()
									oldModel.caption = dataType.toString()
									oldModel.idDataType = dataType.idDataType
									oldModel.type = dataType.dataTypeClass.idDataTypeClass
									oldModel.dataTypeClass = dataType.dataTypeClass.toString()
									oldModel.name = dataType.name
									oldModel.referenceTypeId = dataType.referenceType ? dataType.referenceType.idReferenceType : null
									oldModel.isEditable = dataType.isEditable
									oldModel.format = dataType.dataTypeFormat ? <any>dataType.dataTypeFormat : {}
									oldModel.unitId = dataType.unit ? dataType.unit.idUnit : 0
									oldModel.unitName = dataType.unit ? dataType.unit.toString() : ''
									oldModel.defaultValue = dataType.defaultValue
									oldModel.opState = dataType.opState
									dictionaries.dataTypes[dataType.idDataType] = oldModel
								})

								//result.dataTypeInGroups.forEach(dataTypeInGroup => {
								this.tryGetDictionaryContent<OpDataTypeInGroup>(result, Enums.ReferenceType.IdDataTypeInGroup).forEach((dataTypeInGroup) => {
									var key = dataTypeInGroup.idDataTypeGroup
									if (!dictionaries.dataTypeInGroups[key]) {
										dictionaries.dataTypeInGroups[key] = []
									}
									if (dictionaries.dataTypeInGroups[key].filter((d) => d.idDataType == dataTypeInGroup.idDataType).length == 0)
										dictionaries.dataTypeInGroups[key].push({
											idDataType: dataTypeInGroup.idDataType,
											description: dataTypeInGroup.descr ? dataTypeInGroup.descr.description : null,
											order: dataTypeInGroup.orderNBR,
										})
								})

								this.userSession
									.getDataProvider()
									.View.getActiveViews()
									.then((activeViews) => {
										activeViews.forEach((activeView) => {
											dictionaries.views[activeView.idReferenceType] = activeView
										})
										dictionariesDefer.resolve(dictionaries)
									})
									.fail(() => {
										dictionariesDefer.reject("Can't download active views")
									})
							})
							.fail(() => {
								dictionariesDefer.reject("Can't download dictionaries")
							})
					} else {
						this.api.dictionary.getDictionaries(true).then((encodedDictionary) => {
							var dictionaries = this.decodeDictionaries(this.decodeString(CommonHelper.Base64.decode(encodedDictionary)))
							dictionariesDefer.resolve(dictionaries)
						})
					}

					return dictionariesDefer.promise.then((dictionaries) => {
						if (dictionaries != null) {
							CommonHelper.checkLocalStorageUsage()
							var encoded = this.encodeDictionaries(dictionaries)
							this.saveDictionaries(encoded, locale, version, userId)
							this.asyncGetReferenceTables()
							return dictionaries
						}
						throw new Error("Can't download dictionaries")
					})
				} else {
					this.asyncGetReferenceTables()
					var dictionaries = this.decodeDictionaries(this.decodeString(dictionariesInfo.dictionary))
					return dictionaries
				}
			})
			.then((dictionaries) => {
				LocalDictionaryFactory.dictionaries = dictionaries
				return dictionaries
			})

		promise.catch((reason) => {
			this.logger.log(reason)
			this.promise = null
			CommonHelper.openInfoPopup(i18n('Common', 'DictionariesProblem'), 'error', 3000)
		})

		this.promise = promise
		return promise
	}

	/**get color for dataType (in chart)
	 * @idDatatype - id data type
	 * @extendedId - id data type or idMeter/serialNbr-idDataType
	 */
	public getSeriesColor(idDataType: number, extendedId?: string | number): ng.IPromise<{ idDataType: number; color: string; isForced: boolean }> {
		return this.getPromise().then((dictionaries: ExtendedDictionaryModel) => {
			const dataTypeGroups: DataTypeGroupModel[] = dictionaries.dataTypeGroups.filter(
				(g) => g.name == Enums.DataTypeGroup.WEBSIMAX_DATA_TYPE_SERIES_COLOR && g.idReferenceType == Enums.ReferenceType.Color
			)

			const groupsIds: number[] = []

			for (let id in dictionaries.dataTypeInGroups) {
				const dataTypeInGroups: DataTypeInGroupModel[] = dictionaries.dataTypeInGroups[id]

				if (dataTypeInGroups.filter((dtig) => dtig.idDataType == idDataType).length > 0) {
					groupsIds.push(+id)
				}
			}

			let color: string = undefined

			dataTypeGroups.forEach((dataTypeGroup: DataTypeGroupModel) => {
				groupsIds.forEach((id: number) => {
					if (dataTypeGroup.idDataTypeGroup == id) {
						color = 'rgba(' + KnownColor.getColor(dataTypeGroup.referenceValue.toString()) + ')'
					}
				})
			})

			const isForcedColor: boolean = !!color

			if (!isForcedColor) {
				if (!this.colors[idDataType]) {
					this.colors[idDataType] = this.generateDarkColorHex()
				}

				if (extendedId != null && extendedId != idDataType && !this.colors[extendedId]) {
					this.colors[extendedId] = this.generateDarkColorHex()
				}

				if (extendedId != null && extendedId != idDataType) {
					color = this.colors[extendedId]
				} else {
					color = this.colors[idDataType]
				}
			}

			return {
				idDataType: idDataType,
				color: color,
				isForced: isForcedColor,
			}
		})
	}

	private restoreDataTypesInActiveViewIfNeeded(activeView: OpView) {
		activeView.columns.forEach((c) => {
			if (!c.dataType && c.idDataType) {
				var dataType: DataTypeModel = LocalDictionaryFactory.dictionaries.dataTypes[c.idDataType]
				if (dataType) {
					// fake object, when be possible remove it
					c.dataType = <any>dataType
					c.dataType.opState = dataType.opState
					c.dataType.toString = () => {
						return dataType.caption
					}
				}
			}
		})
	}

	public getPrimaryKeyColumn(activeViewId) {
		if (LocalDictionaryFactory.dictionaries && LocalDictionaryFactory.dictionaries.views && LocalDictionaryFactory.dictionaries.views[activeViewId]) {
			var activeView = OpView.restore(LocalDictionaryFactory.dictionaries.views[activeViewId])
			this.restoreDataTypesInActiveViewIfNeeded(activeView)
			return activeView.getPrimaryKeyColumn()
		} else return null
	}

	public getActiveView(activeViewId) {
		if (LocalDictionaryFactory.dictionaries && LocalDictionaryFactory.dictionaries.views && LocalDictionaryFactory.dictionaries.views[activeViewId]) {
			var activeView = OpView.restore(LocalDictionaryFactory.dictionaries.views[activeViewId])
			this.restoreDataTypesInActiveViewIfNeeded(activeView)
			return activeView
		} else {
			if (ConfigHelper.getSectionValue(Enums.SimaxConfigSection.Debug) == true) {
				this.logger.log('ActiveView ' + activeViewId + ' not found')
			}
			return null
		}
	}

	public getViewColumnName(activeViewId, dataType: DataType, viewColumnType: ViewColumnType) {
		let activeView = this.getActiveView(activeViewId)
		if (activeView) {
			let getViewColumnParameters = new GetViewColumnOptions(dataType)
			getViewColumnParameters.viewColumnType = viewColumnType
			let col = activeView.getViewColumn(getViewColumnParameters)
			if (col) return col.name
		}
		this.logger.log('ActiveView ' + activeViewId + ' ViewColumn ' + dataType + ' not found')
		return null
	}

	public getSeparateYAxis() {
		return this.getPromise().then((dictionaries) => {
			var dataTypeGroups = dictionaries.dataTypeGroups.filter((g) => g.name == 'WEBSIMAX_DATA_TYPE_SERIES_SEPARATE_Y_AXIS')
			var sepTypes = []

			dataTypeGroups.forEach((dataTypeGroup) => {
				if (dictionaries.dataTypeInGroups[dataTypeGroup.idDataTypeGroup]) {
					dictionaries.dataTypeInGroups[dataTypeGroup.idDataTypeGroup].forEach((dataType) => {
						sepTypes.push(dataType.idDataType)
					})
				}
			})

			return sepTypes
		})
	}

	public getHiddenYAxis() {
		this.getHiddenYAxisSync()
		return this.getDictionary('WEBSIMAX_DATA_TYPE_HIDDEN_Y_AXIS').then((columns) => {
			return columns
		})
	}

	public getHiddenYAxisSync() {
		var dataTypeGroups = LocalDictionaryFactory.dictionaries.dataTypeGroups.filter((g) => g.name == 'WEBSIMAX_DATA_TYPE_HIDDEN_Y_AXIS')

		var hiddenTypes = []
		dataTypeGroups.forEach((dataTypeGroup) => {
			if (LocalDictionaryFactory.dictionaries.dataTypeInGroups[dataTypeGroup.idDataTypeGroup]) {
				LocalDictionaryFactory.dictionaries.dataTypeInGroups[dataTypeGroup.idDataTypeGroup].forEach((dataType) => {
					hiddenTypes.push(dataType.idDataType)
				})
			}
		})

		return hiddenTypes
	}

	public getThreshold() {
		return this.getPromise().then((dictionaries) => {
			var thresholdGroups = dictionaries.dataTypeGroups.filter((group) => group.name == 'WEBSIMAX_MEASUREMENT_THRESHOLD')
			var idDataTypes = []
			for (var id in dictionaries.dataTypeInGroups) {
				var dataTypeInGroup: any[] = dictionaries.dataTypeInGroups[id]
				thresholdGroups.forEach((group) => {
					if (Number(id) == group.idDataTypeGroup) {
						dataTypeInGroup.forEach((dataType) => {
							idDataTypes.push(dataType.idDataType)
						})
					}
				})
			}
			var dataTypes = []
			for (var id in dictionaries.dataTypes) {
				var dataType: ColumnModel = dictionaries.dataTypes[id]
				idDataTypes.forEach((idDataType) => {
					if (Number(id) == idDataType) {
						var type = _.clone(dataType)
						type.id = Number(id)
						type.chartType = 'line'
						dataTypes.push(type)
					}
				})
			}
			return dataTypes
		})
	}

	private randomColor(brightness) {
		function randomChannel(brightness) {
			var r = 255 - brightness
			var n = 0 | (Math.random() * r + brightness)
			var s = n.toString(16)
			return s.length == 1 ? '0' + s : s
		}
		return '#' + randomChannel(brightness) + randomChannel(brightness) + randomChannel(brightness)
	}

	private getRandomColor(): string {
		return `#${Math.floor(Math.random() * 16777215).toString(16)}` //this.randomColor(Math.floor(Math.random() * 10000) / 255)
	}

	private generateDarkColorHex(): string {
		let color = '#'

		for (let i = 0; i < 3; i++) color += ('0' + Math.floor((Math.random() * Math.pow(16, 2)) / 2).toString(16)).slice(-2)

		return color
	}
}
